module.exports = __webpack_public_path__ + "img/brush.0f34495a.svg";